import React from "react";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import { onInvoiceActivity } from "common/signalR";
import InvoiceActivityCard from "./InvoiceActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  documentId: number
  config: server.dto.ActivityPanelConfig
}

const InvoiceActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  const pageLoadCausingInvoiceActions: server.dto.InvoiceActions[] = [
    "lifeCycleToDraft",
    "lifeCycleToReview",
    "lifeCycleToOutstanding",
    "lifeCycleToCompleted"
  ];

  return <ActivityPanel
    activityKey="invoiceV2"
    itemId={props.documentId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.InvoiceV2.ListActivity({ itemId: props.documentId, page, perPage })}
    renderActivity={(activity) => <InvoiceActivityCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onInvoiceActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      if ((iAmActor) && pageLoadCausingInvoiceActions.includes(activity.action.value)) return { refreshActivities: false };

      return { refreshActivities: true };
    }}
  />;
};

export default InvoiceActivityPanel;
